/*
 * fn: getCardRef
 *
 * Gets a cardRef, a cardId and name combination to describe and identify a specific card
 *
 */
import { type CardRefType } from '@/defs/card'
import { slugify } from '@/utils/commonUtil'

import { buildCardId } from './buildCardId'

type Props = {
  collectorNumber?: string
  name: string
  set?: string
  slug?: string
}

export const getCardRef = ({ collectorNumber, name, set, slug }: Props): CardRefType => ({
  cardId: buildCardId({ collectorNumber, set, slug: slug || slugify(name) }),
  name,
})
